import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  // Set the document title and redirect to home
  useEffect(() => {
    document.title = "404 - Page Not Found | Merrvesh";
    
    // Redirect to home page after 2 seconds
    const redirectTimer = setTimeout(() => {
      navigate("/", { replace: true });
    }, 2000);

    // Cleanup timer and restore title on unmount
    return () => {
      clearTimeout(redirectTimer);
      document.title = "MerrVesh";
    };
  }, [navigate]);

  return (
    // Use absolute positioning to override any parent layout constraints
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white text-center px-4">
      <h1 className="text-[#2D2D2D] text-8xl md:text-[200px] font-bold leading-none select-none">
        404
      </h1>
      
      <h2 className="text-xl md:text-2xl font-medium text-[#2D2D2D] mt-4 uppercase tracking-wider">
        OOPS! PAGE NOT FOUND
      </h2>
      
      <p className="mt-6 text-lg text-[#2D2D2D] max-w-lg">
        WE ARE SORRY, BUT THE PAGE YOU REQUESTED WAS NOT FOUND
      </p>
      
      <p className="mt-4 text-base text-gray-600">
        Redirecting to homepage in 2 seconds...
      </p>
      
      <button 
        onClick={() => navigate("/", { replace: true })}
        className="mt-8 px-8 py-3 bg-[#2D2D2D] text-white rounded hover:bg-black transition-colors duration-300"
      >
        GO TO HOMEPAGE NOW
      </button>
    </div>
  );
};

export default NotFoundPage; 